export const dynamicConfigurationTransformer = (
  configurations,
  recommendationRules = [],
  guestRangeId
) => {
  const transformed = configurations.map((config) => {
    const rules = recommendationRules.find(
      (rule) => rule.id === config.order_criteria_id
    );

    const guestRange = config.guest_range_config.find(
      (range) => range.guest_range_id === guestRangeId
    );

    return {
      ...config,
      id: config.category_sears_id,
      categoryId: config.category_sears_id,
      name: config.category_name,
      rules: rules || {},
      guestRange,
    };
  });

  return transformed;
};

export const rulesTransformer = (recommendationRules) =>
  recommendationRules.map((rule) => ({
    ...rule,
    value: rule.criteria,
  }));
